import { userConstants } from "../../constant";

const initialState = {
  is_public: false,
  share_token: null,
};

export function wishlistShare(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_WISHLIST_SHARE_STATUS:
    case userConstants.TOGGLE_WISHLIST_SHARE:
      return {
        is_public: action.payload.is_public,
        share_token: action.payload.share_token,
      };
    default:
      return state;
  }
}
